import { useCallback, useState } from 'react';
import axios from 'Axios';
import { useDispatch } from 'react-redux';
import { fetchUser, setToken } from 'Actions';
import { toastify, api, currentUser, clx } from 'Utils';
import { ModalBox, Button, FieldMessage, FormMessage } from 'Elements';
import styles from 'partials/modalbox/modal-form.module.scss';

export const ModalBoxLogin = ({
	isOpen,
	size,
	onClose,
	onToggleRegister,
	onToggleForget
}) => {
	const initialState = () => ({
		fields: {
			username: '',
			password: ''
		},
		isSubmiting: false,
		messages: {},
		errors: {},
		message: {}
	});

	const [state, setState] = useState(initialState());
	const dispatch = useDispatch();

	const resetState = useCallback(() => {
		setState(initialState());
	}, []);

	const handleInput = (e) => {
		const fields = state.fields;
		const target = e.target;
		fields[target.name] = target.value;
		setState((prev) => ({
			...prev,
			fields
		}));
	};

	const validateForm = () => {
		let errors = {};
		const fields = state.fields;
		let formIsValid = true;
		if (!fields.username) {
			formIsValid = false;
			errors['username'] = 'نام کاربری را وارد کنید';
		}
		if (!fields.password) {
			formIsValid = false;
			errors['password'] = 'کلمه عبور را وارد کنید';
		}

		setState((prev) => ({
			...prev,
			errors
		}));
		return formIsValid;
	};

	const submitForm = () => {
		const data = state.fields;
		if (validateForm()) {
			setState((prev) => ({
				...prev,
				isSubmiting: true
			}));

			axios.post(api.login, data).then((res) => {
				let data = res.data;
				setState((prev) => ({
					...prev,
					isSubmiting: false
				}));
				if (res.status === 200) {
					if (data.success) {
						const token = data.result.token;
						currentUser.setToken(token);
						dispatch(setToken(token));
						dispatch(fetchUser());
						onClose();
					} else {
						// TODO: check if user does not exist or something else
						setState((prev) => ({
							...prev,
							messages: data.message
						}));
						// toastify(data.message);
					}
				} else {
					toastify('خطا در برقراری ارتباط با سرور');
				}
			});
		}
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		submitForm();
	};

	return (
		<ModalBox
			isOpen={isOpen}
			size={size}
			onClose={onClose}
			onDestroy={resetState}>
			<header className={styles.header}>
				<h3 className={styles.headerTitle}>ورود</h3>
			</header>
			<div className={styles.body}>
				<form className={styles.form} onSubmit={handleSubmit}>
					{Object.keys(state.messages).map((keys, idx) => {
						const [message] = state.messages[keys];
						return <FormMessage key={idx} text={message} />;
					})}
					<div className={styles.fieldset}>
						<label htmlFor="username" className={styles.label}>
							نام کاربری
						</label>
						<input
							id="username"
							name="username"
							type="text"
							className={[styles.input, styles.input_ltr].join(
								' '
							)}
							onChange={handleInput}
						/>
						{state.errors.username && (
							<FieldMessage text={state.errors.username} />
						)}
					</div>
					<div className={styles.fieldset}>
						<label htmlFor="password" className={styles.label}>
							کلمه عبور
							<span
								role="button"
								tabIndex="-1"
								onKeyDown={onToggleForget}
								className={styles.labelLink}
								onClick={onToggleForget}>
								کلمه عبور را فراموش کرده اید؟
							</span>
						</label>
						<input
							id="password"
							name="password"
							type="password"
							className={[styles.input, styles.input_ltr].join(
								' '
							)}
							onChange={handleInput}
						/>
						{state.errors.password && (
							<FieldMessage text={state.errors.password} />
						)}
					</div>
					<div className={styles.fieldset}>
						<Button
							className={clx(styles.submit, styles.submitFull)}
							disabled={state.isSubmiting}
							type="submit">
							ورود به حساب کاربری
						</Button>
					</div>
					<div className={styles.fieldset}>
						<p className={styles.text}>
							عضو نیستید؟ &nbsp;
							<Button
								className={styles.textLink}
								onClick={onToggleRegister}>
								ایجاد حساب کاربری
							</Button>
						</p>
						<p className={styles.text}></p>
					</div>
				</form>
			</div>
		</ModalBox>
	);
};
